import { Device } from "../../../misc/api/DeviceLinkApi/Devices";
import * as P230In2itiveApi from '../../../misc/api/DeviceLinkApi/P230In2itive';
import { isIn2itiveError } from "../../../misc/api/DeviceLinkApi/P230In2itive";

export const P230In2itiveEDiaryCheckExistingData = async (device: Device, raiseConfigurationError: (message: string, isWarning: boolean) => void): Promise<boolean> => {
    try {
        const sessionResult = await P230In2itiveApi.GetSession(device.id);
        if (isIn2itiveError(sessionResult)) {
            if (sessionResult.error.message === "no data") {
                return false;
            }
        }
    } catch (err) {
        raiseConfigurationError(err, true);
    }
}
